<template>
  <div>
    <h1 class="choice-title blank-wrap" :class="{ required: data?.isRequired }">
      <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
        `${quesIndex + 1}、`
      }}</span>
      <template v-for="(item, index) in showList" :key="`${index}${item}`">
        <span class="ques-text">{{ item }}</span>
        <!-- <label :for="`inputId${index}`"><span>{{ answerList[index]?.answerContent }}</span></label> -->
        <input
          :disabled="isReview"
          class="blank-input"
          :id="`inputId${index}`"
          @blur="handleInputBlur"
          v-model="answerList[index].answerContent"
          v-if="index !== showList.length - 1"
          type="text"
        />
      </template>
      <span v-if="$store.getters?.isShowType" class="title-tip">
        (完型填空)
      </span>
    </h1>
    <template
      v-if="
        data.questionType !== 11 &&
          data.questionType !== 16 &&
          data.questionType !== 25
      "
    >
      <div v-if="isReview">
        <template class="feedback animate__animated animate__fadeInDown">
          <div v-if="rightType === 0" class="left red">
            答案：错误
          </div>
          <div v-if="rightType === 1" class="left green">答案：正确</div>
          <div v-if="rightType === 2" class="left green">答案：部分正确</div>
          <div class="right">
            正确答案：{{ rightAnswerList && rightAnswerList.join(',') }}
          </div>
        </template>
        <div
          v-if="
            data?.explanation &&
              $store.getters.getQuesSetting?.isExplanation === 2
          "
          class="explanation"
        >
          <img src="@/assets/img/explanation.png" alt="" />
          <p>解析：{{ data.explanation }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import '../choice/css/choice.scss'
import { ref, onMounted, defineProps, computed } from 'vue'
import { onBeforeRouteUpdate } from 'vue-router'
const props = defineProps({
  data: {
    type: Object,
    default: null
  },
  quesIndex: {
    type: Number,
    default: 0
  },
  isReview: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['inputChange', 'changeVerify'])

const value = ref('')

const rightType = ref(0)

const rightAnswerList = props.data.optionVoList.map(item => item.answer)

// 回顾设置对错
if (props.data.value) {
  const valueList = Array.from(new Set(JSON.parse(props.data.value)))

  const res = valueList.filter(item => rightAnswerList.includes(item))

  // 1 为全部命中答案正确
  if (res.length === rightAnswerList.length) {
    rightType.value = 1
  }
  // 2 为部分正确
  if (res.length > 0 && res.length < rightAnswerList.length) {
    rightType.value = 2
  }
}

const showList = computed(() => {
  return props.data?.title.trim().split(/__+/g)
})

const answerList = computed(() => {
  const values = props.data?.value ? JSON.parse(props.data?.value) : []

  return props.data?.optionVoList?.map((item, index) => {
    return {
      questionKey: item.questionKey,
      optionKey: item.optionKey,
      answerContent: values[index] || ''
    }
  })
})

const handleInputBlur = () => {
  emits('inputChange', {
    questionKey: props.data.questionKey,
    questionType: props.data.questionType,
    answers: [...answerList.value]
  })
}

onMounted(() => {
  if (props.data.value) {
    value.value = props.data.value
  }
})

onBeforeRouteUpdate(() => {
  if (props.data.value) {
    value.value = props.data.value
  }
})
</script>

<style lang="scss" scoped>
.blank-wrap {
  line-height: normal;
  // line-height: 1.7;

  .ques-text {
    margin-left: 0.1rem;
  }
}
.blank-input {
  margin: 0.1rem 0.14rem;
  outline: none;
  width: 3.8rem;
  height: 1.28rem;
  font-size: 0.68rem;
  border: 1px solid #e0e0e0;
}
</style>
